import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import SupportUs from './pages/SupportUs'
import { PrivacyPolicy, TermsOfService, CookiePolicy, DPA } from './features/legal'
import GoogleAnalytics from './components/common/GoogleAnalytics'
import { GA4_CONFIG, isAnalyticsEnabled } from './config/analytics'

function App() {
  return (
    <Router>
      {/* Google Analytics 4 - Only load if analytics is enabled */}
      {isAnalyticsEnabled() && (
        <GoogleAnalytics measurementId={GA4_CONFIG.MEASUREMENT_ID} />
      )}
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/support-us" element={<SupportUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/dpa" element={<DPA />} />
      </Routes>
    </Router>
  )
}

export default App